﻿
cb.define([], function() {
	var ST_st_batchnolist_VM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			//拼规格值到一个列中
			var gridModel = viewmodel.getGridModel();
			var map = ['retailskus_free1', 'retailskus_free2', 'retailskus_free3', 'retailskus_free4', 'retailskus_free5', 'retailskus_free6', 'retailskus_free7', 'retailskus_free8', 'retailskus_free9', 'retailskus_free10'];
			gridModel.on('afterSetDataSource', function(data){
				data.forEach(function(row, index) {
					let value = '';
					map.forEach(function(cellName) {
						let column = gridModel.getColumn(cellName);
						let name = column.cShowCaption;
						let text = gridModel.getCellValue(index, cellName);
						if(text){
							value += name + ':' + text + ';';
						}
					}, this);

					if(value.length > 1){
						value = value.substring(0, value.length - 1);
						gridModel.setCellValue(index, 'skuvalue', value);
					}
					
				}, this);
			});
		},

	}
	try {
		module.exports = ST_st_batchnolist_VM_Extend;
	} catch(error) {

	}
	return ST_st_batchnolist_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_batchnolist_VM.Extend.js